import { render, staticRenderFns } from "./AreaEventHistory.vue?vue&type=template&id=9a5544e0&scoped=true"
import script from "./AreaEventHistory.vue?vue&type=script&lang=ts"
export * from "./AreaEventHistory.vue?vue&type=script&lang=ts"
import style0 from "./AreaEventHistory.vue?vue&type=style&index=0&id=9a5544e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5544e0",
  null
  
)

export default component.exports